export const customFieldConstants = {
    GET_CUSTOM_FIELD_REQUEST: 'GET_CUSTOM_FIELD_REQUEST',
    GET_CUSTOM_FIELD_SUCCESS: 'GET_CUSTOM_FIELD_SUCCESS',
    GET_CUSTOM_FIELD_FAILURE: 'GET_CUSTOM_FIELD_FAILURE',

    UPDATE_CUSTOM_FIELD_REQUEST: 'UPDATE_CUSTOM_FIELD_REQUEST',
    UPDATE_CUSTOM_FIELD_SUCCESS: 'UPDATE_CUSTOM_FIELD_SUCCESS',
    UPDATE_CUSTOM_FIELD_FAILURE: 'UPDATE_CUSTOM_FIELD_FAILURE',

    DELETE_CUSTOM_FIELD_REQUEST: 'DELETE_CUSTOM_FIELD_REQUEST',
    DELETE_CUSTOM_FIELD_SUCCESS: 'DELETE_CUSTOM_FIELD_SUCCESS',
    DELETE_CUSTOM_FIELD_FAILURE: 'DELETE_CUSTOM_FIELD_FAILURE',

    CREATE_CUSTOM_FIELD_REQUEST: 'CREATE_CUSTOM_FIELD_REQUEST',
    CREATE_CUSTOM_FIELD_SUCCESS: 'CREATE_CUSTOM_FIELD_SUCCESS',
    CREATE_CUSTOM_FIELD_FAILURE: 'CREATE_CUSTOM_FIELD_FAILURE',

    LIST_CUSTOM_FIELDS_REQUEST: 'LIST_CUSTOM_FIELDS_REQUEST',
    LIST_CUSTOM_FIELDS_SUCCESS: 'LIST_CUSTOM_FIELDS_SUCCESS',
    LIST_CUSTOM_FIELDS_FAILURE: 'LIST_CUSTOM_FIELDS_FAILURE',

    LIST_CUSTOM_FIELDS_FOR_MESSAGE_REQUEST: 'LIST_CUSTOM_FIELDS_FOR_MESSAGE_REQUEST',
    LIST_CUSTOM_FIELDS_FOR_MESSAGE_SUCCESS: 'LIST_CUSTOM_FIELDS_FOR_MESSAGE_SUCCESS',
    LIST_CUSTOM_FIELDS_FOR_MESSAGE_FAILURE: 'LIST_CUSTOM_FIELDS_FOR_MESSAGE_FAILURE',

    FETCH_CUSTOM_FIELDS_REQUEST: 'FETCH_CUSTOM_FIELDS_REQUEST',
    FETCH_CUSTOM_FIELDS_SUCCESS: 'FETCH_CUSTOM_FIELDS_SUCCESS',
    FETCH_CUSTOM_FIELDS_FAILURE: 'FETCH_CUSTOM_FIELDS_FAILURE',

    CLEAR_CUSTOM_FIELDS: 'CLEAR_CUSTOM_FIELDS',
    REMOVE_CUSTOM_FIELD_FROM_STORE: 'REMOVE_CUSTOM_FIELD_FROM_STORE',
};